<template>
	<page-content-layout class="movings" title="Movings">
		<button-view slot="tools" label="Opret" @click="select" />
		<div class="layout">
			<date-picker-std-view v-model="date" class="date" :status="_state" @browse="updateState" />
			<div class="tasks"></div>
			<new-table-view class="list" @itemClick="itemClick" :columns="[
				/*{
					label: 'Status',
					name: ['_embedded', 'status'],
					translation: _status,
					template: {
						name: 'status',
						params: {
							color: {
								name: ['_embedded', 'status'],
								translation: _statusColors
							},
							description: {
								name: ['_embedded', 'status'],
								translation: _statusDesc
							}
						}
					}
				},*/
				/*{
					label: 'Oprettet',
					name: 'created',
					filter: 'timestamp'
				},*/
				{
					label: 'Type',
					name: 'type',
					translation: _types,
					template: {
						name: 'status',
						params: {
							color: {
								name: 'type',
								translation: _typeColors
							},
							description: {
								data: ''
							},
							subtitle: {
								name: ['_embedded', 'sub_type', 'label'],
								default: null
							}
						}
					}
				},
				{
					label: 'Nr',
					name: 'num',
					filter: 'integer'
					//filter: 'float',
					//align: 'right'
				},
				/*{
					label: 'Kunde',
					name: ['_embedded', 'contact', 'name']
				},*/
				{
					label: 'Navn',
					name: 'name'
				},
				{
					label: 'Ansvarlig',
					name: ['_embedded', 'employee', 'name']
				},
				{
					label: 'Kostpris',
					data: '-'
				},
				{
					label: '',
					name: 'context',
					align: 'right',
					template: {
						name: 'button',
						label: '...'
					}
				}	
			]" :items="items" @context="itemContext" />
		</div>
	</page-content-layout>
</template>

<script>
	import merge from '../functions/merge'

	import NewTableView from '../views/NewTableView'

	import ContextPopupView from '../views/ContextPopupView'

	import SurveyTaskModel from '../model/SurveyTask'
	import SurveyTaskWindow from '../windows/SurveyTaskWindow'

	import MoveTaskModel from '../model/MoveTask'
	import MoveTaskWindow from '../windows/MoveTaskWindow'

	import CourierTaskModel from '../model/CourierTask'
	import CourierTaskWindow from '../windows/CourierTaskWindow'

	import TaskModel from '../model/Task'
	import TaskWindow from '../windows/TaskWindow'

	import DatePickerStdView from '../views/DatePickerStdView'

	import { bus } from '../../bus'

    export default {
		data() {
			return {
				date: (new Date()).format('Y-m-d'),
				items: [],
				colors: [],
				status: [],
				state: [],
				types: []
			};
		},
		components: {
			'NewTableView': NewTableView,
			'DatePickerStdView': DatePickerStdView
		},
		watch: {
			date(n, o) {
				this.update();
			}
		},
		computed: {
			_status() {
				var r = [];

				for (var i = 0; i < this.status.length; ++i) {
					r[this.status[i].name] = this.status[i].label;
				}

				return r;
			},
			_types() {
				var r = [];

				for (var i = 0; i < this.types.length; ++i) {
					r[this.types[i].name] = this.types[i].label;
				}

				return r;
			},
			_typesFull() {
				var r = [];

				for (var i = 0; i < this.types.length; ++i) {
					r[this.types[i].name] = this.types[i];

					if (this.types[i].super == 'general') {
						r[this.types[i].name].window 	= TaskWindow;	
						r[this.types[i].name].model 	= TaskModel; 
					} else {
						r[this.types[i].name] = this.types[i];

						switch (this.types[i].name) {
							case 'survey': 		r[this.types[i].name].window = SurveyTaskWindow;	r[this.types[i].name].model = SurveyTaskModel; 		break;
							case 'move': 		r[this.types[i].name].window = MoveTaskWindow; 		r[this.types[i].name].model = MoveTaskModel;		break;
							//case 'compound': 	r[this.types[i].name].window = CompoundTaskWindow; 	r[this.types[i].name].model = CompoundTaskModel;	break;
							case 'pickup': 		r[this.types[i].name].window = CourierTaskWindow; 	r[this.types[i].name].model = CourierTaskModel;		break;
							case 'delivery':	r[this.types[i].name].window = CourierTaskWindow; 	r[this.types[i].name].model = CourierTaskModel;		break;
						}
					}
				}

				return r;
			},
			_state() {
				var r = [];

				for (var date in this.state) {
					var s = this.state[date];

					r.push({
						date: date,
						color: 'gray',
						label: ''
					});
				}

				return r;
			},
			_statusColors() {
				var r = [];

				for (var i = 0; i < this.status.length; ++i) {
					r[this.status[i].name] = this._colors[this.status[i].color];
				}

				return r;
			},
			_typeColors() {
				var r = [];

				for (var i = 0; i < this.types.length; ++i) {
					r[this.types[i].name] = this.types[i].color;
				}

				return r;
			},
			_statusDesc() {
				var r = [];

				for (var i = 0; i < this.status.length; ++i) {
					r[this.status[i].name] = this.status[i].desc;
				}

				return r;
			},
			_colors() {
				var r = [];

				for (var i = 0; i < this.colors.length; ++i) {
					r[this.colors[i].name] = this.colors[i].color;
				}

				return r;
			},
			_actions() {
				var r = [];

				var self = this;

				for (var i = 0; i < this.types.length; ++i) {
					r.push(
						function () {
							var j = i;

							return {
								label: self.types[j].label,
								action: function () {
									self.open(self.types[j].name);
								}
							};
						}(),
					);
				}

				return r;
			}
		},
		methods: {
			updateState(year, month) {
				var self = this;

				// Status
				this.axios
					.get('/planning/status/' + year + '/' + month + '/')
					.then(function (r) {
						self.state = r.data;
					});
			},
			itemContext(item, event) {
				event.stopPropagation();

				var self = this;

				var actions = [];

				if (item.type == 'survey') {
					actions.push({
						label: 'Print privat',
						action: async function () {
							window.open(process.env.VUE_APP_API + '/planning/tasks/' + item.id + '/private/print/?token=' + self.$store.state.auth);
						}
					});

					actions.push({	
						label: 'Print erhverv',
						action: async function () {
							window.open(process.env.VUE_APP_API + '/planning/tasks/' + item.id + '/business/print/?token=' + self.$store.state.auth);
						}
					});

					actions.push(null);
				}

				actions.push({
					label: 'Slet',
					action: async function () {
						if (await TaskModel.delete(self.axios, item.id)) {
							self.update();
						}
					}
				});

				this.$store.state.popupController.toggle(ContextPopupView, {
					anchor: event.currentTarget,
					align: 'left',
					actions: actions
				});
			},
			async itemClick(item) {
				this.open(item.type, item.id);
			},
			select(event) {
				var self = this;

				this.$store.state.popupController.toggle(ContextPopupView, {
					anchor: event.currentTarget,
					align: 'right',
					actions: this._actions
				});
			},
			async open(type, id) {
				var self 	= this;
				var window 	= this._typesFull[type].window;
				var model 	= this._typesFull[type].model;

				var ent = id ? await model.read(self.axios, id) : model.entity();

				if (!id) {
					ent.employee_id 		= self.$store.state.employee.id;
					ent.department_id 		= self.$store.state.employee.department_id;
					ent._embedded.employee	= self.$store.state.employee;
					ent.type				= type;
				}

				this.$store.state.windowStack.push(window, {
					value: ent,
					async submit(entity) {
						if (await model.save(self.axios, entity)) {
							self.$store.state.windowStack.pop();
							bus.$emit('update');
						}
					}
				});
			},
			async update() {
				this.items = null;
				var d = new Date(this.date);
				this.items = (await TaskModel.readPage(this.axios, d.getFullYear(), d.getMonth() + 1, d.getDate()))._items;
				this.updateState((new Date(this.date)).getFullYear(), (new Date(this.date)).getMonth() + 1);
			}
		},
		mounted() {
			this.update();

			var self = this;

			this.axios
				.get('/tasks/status/')
				.then(function (r) {
					self.status = r.data._items;
				});

			this.axios
				.get('/tasks/types/')
				.then(function (r) {
					self.types = r.data._items;
				});

			this.axios
				.get('/config/status/colors/')
				.then(function (r) {
					self.colors = r.data._items;
				});

			bus.$on('update', function () {
				self.update();
			});

			bus.$on('clear', function () {
				self.items = null;
			});
		},
		beforeRouteLeave(to, from, next) {
			bus.$off('update');
			bus.$off('clear');

			next();
		}
    }
</script>

<style lang="scss" scoped>
	.layout {
		width: 100%;
		height: 100%;
		display: grid;
		grid-template-columns: 320px 1fr;
		grid-template-rows: 290px 1fr;

		& > .new-table-view {
			width: 100%;
			height: 100%;
		}
	}

	.date {
		grid-column: 1;
		grid-row: 1;
		background-color: #f0f0f0;
		padding: 30px;
	}

	.tasks {
		grid-column: 1;
		grid-row: 2 / 3;
		background-color: #f0f0f0;		
	}

	.list {
		grid-column: 2 / 3;
		grid-row: 1 / 3;
		border-left: 1px solid #cecece;
	}
</style>